
import React, { useState } from 'react';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import { AdminSidebar } from './AdminSidebar';
import Header from '@/components/HeaderUpdated';
import Footer from '@/components/Footer';

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export function AdminLayout({ children, title = "Dashboard Administrativo" }: AdminLayoutProps) {
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  return (
    <SidebarProvider defaultOpen={false}>
      <div className="min-h-screen flex w-full bg-brand-darker">
        <AdminSidebar
          isHovered={isSidebarHovered}
          onHoverChange={setIsSidebarHovered}
        />
        <SidebarInset className="flex-1">
          <div className="flex flex-col min-h-screen">
            <div style={{ marginLeft: isSidebarHovered ? '0px' : '16px' }} >
              <Header />
            </div>
            <main className="flex-grow">
              <div className="border-b border-brand-gray bg-brand-darker p-4">
                <div className="flex items-center gap-4">
                  <h1 className="text-2xl font-bold text-white p-2">{title}</h1>
                </div>
              </div>
              <div className="p-2 text-white">
                {children}
              </div>
            </main>
            <Footer />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
